<template>
  <!-- PAGAMENTOS  -->
  <v-card class="py-0 mt-4">
    <v-card-text class="py-0 mt-0">
      <v-card-text class="title py-0 px-0"> Pagamentos </v-card-text>
      <hr class="w-100" />
      <v-row v-if="item.contractTypeId === 'CPA'" class="mt-0">
        <!-- Tipos de comissoes -->
        <v-col cols="6" class="modal-cadastro-form-col-imput" sm="4"> 
          <v-autocomplete
            tabindex="1"
            class="contrato"
            v-model.lazy="itemPagamentos.comissionTypeId"
            :items="listTipeSelectComissionFilter('CPA')"
            label="Tipos de Comissões"
            @input="$v.itemPagamentos.comissionTypeId.$touch()" 
            @blur="$v.itemPagamentos.comissionTypeId.$touch()"
            v-on:keyup="searchAutoCompleteTiposComissoes"
            :search-input.sync="searchTextTipoComissoes"
            :error-messages="comissionTypeIdErrors"
            :loading="isLoadingAutoCompleteTipoComissoes"
            :disabled="listPagamentos.length > 0"
            />
        </v-col>

        <!-- minValue -->
        <v-col class="modal-cadastro-form-col-imput ">
          <v-currency-field
            :autoDecimalMode="false"
            :decimalLength="0"
            :valueAsInteger="true"
            v-model="itemPagamentos.minRange"
            label="QTD Inícal:"
            :precision="{min: 0, max: 1}"
            :useGrouping="false"
            prefix=""
            class="mt-5"
            @input="$v.itemPagamentos.minRange.$touch()" 
            @blur="$v.itemPagamentos.minRange.$touch()"
            :key="keyComponent"
            dense />
          </v-col>
          
          <!-- end -->
          <v-col class="modal-cadastro-form-col-imput">
            <v-currency-field
                :autoDecimalMode="false"
                :decimalLength="0"
                :valueAsInteger="true"
                v-model="itemPagamentos.maxRange"
                label="QTD Final:"
                :useGrouping="false"
                prefix=""
                class="mt-5"
                @input="$v.itemPagamentos.maxRange.$touch()" 
                @blur="$v.itemPagamentos.maxRange.$touch()"
                :key="keyComponent + 1"
                dense />

          </v-col>

        <!-- value -->
        <v-col class="modal-cadastro-form-col-imput mt-4 pe-0">
          <v-currency-field v-model="itemPagamentos.cpaValue" label="Valor:" dense   @input="$v.itemPagamentos.cpaValue.$touch()" @blur="$v.itemPagamentos.cpaValue.$touch()" />
        </v-col>
        
        <v-col cols="12" class="modal-cadastro-form-col-imput mt-2" sm="3">
          <v-btn :color="variables.colorSecondary" @click.prevent="add()" dark>Add</v-btn>
        </v-col>

        <v-col cols="12 py-0 px-0">
          <v-card-text class="pt-0">
            <v-data-table
              :headers="headers"
              :items="listPagamentos"
              :loading="loadingTableValues"
              height="auto"
              flat
              dense
              :items-per-page="10">
              <template v-slot:body="{ itens }">
                <tbody> 
                  <tr v-for="(item, index) in listPagamentos" :key="index" >
                    <td>{{ item.minRange }}</td>
                    <td>{{ item.maxRange }}</td>
                    <td>{{ item.cpaValue | currency }} </td>
                    <td>
                      <v-icon small @click="deletePgt(index)" > delete </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card-text>
        </v-col>

      </v-row>
    </v-card-text>
  </v-card>
  </template>
<script>
// eslint-disable-next-line
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { minValue, required } from 'vuelidate/lib/validators'
import variables from '@/assets/styles/helpers/_variables.scss'
import autoCompleteTipoComissoes from '../mixins/autoCompleteTipoComissoes'
import validacao from './validacao'
// eslint-disable-next-line
import { filter, size } from 'lodash'
export default {
  name: 'ContratosPagamentos',
  props: ['item'],
  mixins: [validationMixin, autoCompleteTipoComissoes],
  data: () => ({
    loadingTableValues: false,
    keyComponent: 0,
    config: {
      locale: "pt-BR",
      prefix: "",
      suffix: "",
      length: 11,
      precision: 2
    },
    pagamentos: {
      deste: '1',
      ate: '100',
      value: 1000
    },
    headers: [
      { align: 'start', class: 'table-header', text: 'QTD Inicial', value: 'minRange' },
      { align: 'start', class: 'table-header', text: 'QTD Final', value: 'maxRange' },
      { align: 'start', class: 'table-header', text: 'Valor:', value: 'value' },
      { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters('afiliadosContratos', ['itemPagamentos', 'listPagamentos', 'listTypeSelectOperators', 'listOperatorContract', 'listTipeSelectComissionFilter']),
    variables: () => variables,
    ...validacao
  },
  methods: {
    ...mapActions('afiliadosContratos', ['addPagamentos', 'deletePagamentos', 'clearPagamentos', 'incrementPagamentos', 'listLancamentoRangeValores']),

    async add () {
      if (this.$v.itemPagamentos.$invalid) {
        this.$v.itemPagamentos.$touch()
        return false 
      }

      if (size(this.itemPagamentos) === 3) {
        errorSnackbar('Error: Limite de cadastros de Pagamentos atingido!')
      }

      await this.addPagamentos(this.itemPagamentos)
      this.keyComponent++
      this.incrementPagamentos()
    },

    clear () {
      this.clearPagamentos()
      this.keyComponent = 0
      this.$v.itemPagamentos.$reset()
    },

    deletePgt (idx) {
      this.deletePagamentos(idx)
      this.clearPagamentos()
      this.$v.itemPagamentos.$reset()
    }
  },
  
  validations () {
    /* validacao valores ranges */
    const valores = this.itemPagamentos.minRange
    return  {
      itemPagamentos: {
        comissionTypeId: { required },
        minRange: {
          required,
          minValue: minValue(0.1)
        },
        maxRange: {
          required,
          minValue: minValue(valores),
          // minValueExist: () => {
          //   let minValues = map(self.listPagamentos, v => v.maxRange).filter(v => valoresMax <= v)

          //   if (isEdit) {
          //     const dados = filter(self.listPagamentos, (v, k) => k !== isEdit)
          //     minValues = map(dados, v => v.maxRange).filter(v => valoresMax <= v)
          //   }
          //   return size(minValues) ? !!0 : !!1
          // }
        },
        cpaValue: { required }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    
</style>